export default (theme) => ({
  root: {
    padding: "80px 0 0 0",
    // backgroundColor: '#E5E5E5'
    fontFamily: "'Open Sans', sans-serif",
  },
  button: {
    height: 40,
    marginBottom: 24,
    marginRight: 24,
    marginLeft: 24,
    minWidth: 150
  },
  topButton: {
    // display: "none",
    position: "fixed",
    bottom: "20px",
    right: "30px",
    zIndex: 99,
    fontSize: "18px",
    border: "none",
    outline: "none",
    backgroundColor: "#FF5A34",
    color: "white",
    cursor: "pointer",
    padding: "15px",
    borderRadius: "4px",
  },
  // namecol: {
  //   // width: "920px"
  // },

  // field: {
  //   width: "400px",
  //   // border: "1px solid black",
  //   display: "table"
  // },

  // label: {
  //   whiteSpace: "nowrap",
  //   display: "table-cell",
  //   // width: "1px"
  // },
  // value: {
  //   border: "1px solid black",
  //   whiteSpace: "nowrap",
  //   display: "table-cell",
  //   width: "20px"
  // },
  // cartlabel: {
  //   whiteSpace: "nowrap",
  //   display: "table-cell",
  //   width: "1px",
  //   float: "left",
  // },

  // data: {
  //   borderBottom: "solid 1px black",
  //   fontWeight: "normal",
  //   width: "100%",
  //   textAlign: "center",
  //   marginLeft: "10px",
  //   whiteSpace: "nowrap",
  //   display: "table-cell",
  // },

  // row: {
  //   display: "table-row",
  // },
  // ptable: {
  //   borderSpacing: "2px",
  //   borderColor:"grey"
  // }
});
